import React, { useState } from "react";
import { useForm } from "react-hook-form";
import useSnackbarMAS from "utils/useSnackbarMAS/useSnackbarMAS";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import { FormBuilder } from "components/FormBuilder/FormBuilder";
import { LoadingButton } from "@mui/lab";
import { formPreventEnterSubmit } from "utils/utils";
import { OnlineMerchantManagement } from "components/OnlineMerchant/OnlineMerchantManagement";
import usePageState from "utils/usePageState";
import merchantManagement from "routes/merchantManagement";
import usePageWrapper from "utils/usePageWrapper/usePageWrapper";

const AddOnlineEmployee = ({ path, redirectFn }) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "page.merchantManagement.addOnlineEmployee" });
  const { t: tCommon } = useTranslation();
  const { snackbarError, snackbarSuccess } = useSnackbarMAS();
  const pageState = usePageState({ pagePath: path });
  const formProps = useForm({
    mode: "onChange",
  });
  const { handleSubmit } = formProps;
  const { handleApi, PageWrapper, PageOuterContainer, PageStickyFooter } = usePageWrapper();

  const [isLoading, setIsLoading] = useState(false);

  const merchantId = pageState.merchantId;

  const onSubmit = async (formValues) => {
    // const test = true;
    // if (test) {
    //   console.log(OnlineMerchantManagement.PayloadBuilder.createEmployee(formValues));
    //   return;
    // }
    setIsLoading(true);

    const createEmployeeResult = await OnlineMerchantManagement.Api.createEmployee(OnlineMerchantManagement.PayloadBuilder.createEmployee(formValues));
    if (!handleApi(createEmployeeResult)) {
      snackbarError({ message: tLocal("toast.failed") });
    } else {
      snackbarSuccess({ message: tLocal("toast.success") });
      // redirect to employee list (since backend doesn't return employeeId)
      const redirectPath = "/merchant-management/employees/online-employees";
      const payload = {
        name:
          merchantManagement
            .find((tab) => tab.tabName === "Employees")
            .page.find((page) => page.path === redirectPath).name,
        path: redirectPath,
      }
      redirectFn("close", { tabId: path });
      redirectFn("redirectPage", payload);
    }
    setIsLoading(false);
  }

  return (
    <PageOuterContainer>
      <PageWrapper isLoading={isLoading} noPadding>
        <form noValidate onSubmit={handleSubmit(onSubmit)} onKeyDown={formPreventEnterSubmit}>
          <FormBuilder.Section>
            <OnlineMerchantManagement.EmployeeForm.InfoSection
              formProps={formProps}
              merchantId={merchantId}
              isCreate
              isLoading={isLoading}
            />
          </FormBuilder.Section>
          <PageStickyFooter>
            <Stack direction="row" justifyContent="flex-end" gap={2}>
              <LoadingButton
                key="submit"
                variant="normal-button"
                type="submit"
                loading={isLoading}
              >
                {tCommon("common.submit")}
              </LoadingButton>
            </Stack>
          </PageStickyFooter>
        </form>
      </PageWrapper>
    </PageOuterContainer>
  )
};

export default React.memo(AddOnlineEmployee);
